// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202610010105/js/" + chunkId + "." + {"44":"423f6e4c","225":"ee9ec52c","481":"e4e074e1","486":"ae947b10","770":"330a8ba9"}[chunkId] + ".0.3976267588772818.chunk.js";
};